import { inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { LegalEntityFields, ComparatorOperators, GetAuditTypeGQL, GetAuditTypeQuery, GetPlanningDashboardCountersGQL, GetPlanningDashboardCountersQuery, GetPlanningDashboardGQL, GetPlanningDashboardQuery, GetYearsGQL, GetYearsQuery, LegalEntityQueryComplexInput, LegalEntitySimpleQueryInput, OperatorInput, PagingInput, ProposalQueryInput, GetPlanningPanelFiltersQuery, GetPlanningPanelFiltersGQL, GetYearsRaGQL, GetYearsRaQuery } from "../../../graphql/generated";

@Injectable({
    providedIn: 'root'
})
export class PlanningPanelService {
    private readonly GetAuditTypeGQL: GetAuditTypeGQL = inject(GetAuditTypeGQL)
    private readonly GetPlanningDashboardGQL: GetPlanningDashboardGQL = inject(GetPlanningDashboardGQL)
    private readonly GetYearsGQL: GetYearsGQL = inject(GetYearsGQL);
    private readonly GetYearsRaGQL: GetYearsRaGQL = inject(GetYearsRaGQL);
    private readonly GetPlanningDashboardCountersGQL: GetPlanningDashboardCountersGQL = inject(GetPlanningDashboardCountersGQL);
    private readonly GetPlanningPanelFiltersGQL: GetPlanningPanelFiltersGQL = inject(GetPlanningPanelFiltersGQL);

    getLegalEntities(
        year: number,
        typeOfAudit: string[],
        parameters?: any
    ): Observable<GetPlanningDashboardQuery['getPlanningDashboard']> {
        // return of(PLANNING_PANEL as GetPlanningDashboardQuery['getPlanningDashboard']).pipe(delay(2000));
        const param = convertLazyLoadToComplexWithPage(parameters);
        return this.GetPlanningDashboardGQL.fetch({ typeOfAudit, year, page: param.page, query: param.query }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.getPlanningDashboard))
    }

    getTypeOfAudit(): Observable<GetAuditTypeQuery['getTypeOfAudit']> {
        // return of(TYPE_OF_AUDIT).pipe(delay(1000));
        return this.GetAuditTypeGQL.fetch({}, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.getTypeOfAudit))
    }

    getYears(): Observable<GetYearsQuery['getAvailableYears']> {
        return this.GetYearsGQL.fetch({}, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.getAvailableYears))
    }

    getYearsRA(): Observable<GetYearsRaQuery['getAvailableYearsForAuditPlanningDashboard']> {
        return this.GetYearsRaGQL.fetch({}, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.getAvailableYearsForAuditPlanningDashboard))
    }

    getPlanningDashboardCounters(typeOfAudit: string[], year: number): Observable<GetPlanningDashboardCountersQuery['getPlanningDashboardCounters']> {
        const types = typeOfAudit.map(t => Number(t))
        return this.GetPlanningDashboardCountersGQL.fetch({ typeOfAudit: types, year }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.getPlanningDashboardCounters))
    }

    getPlanningPanelFilters(year: number): Observable<GetPlanningPanelFiltersQuery['legalEntitiesByCampaignYear']> {
        return this.GetPlanningPanelFiltersGQL.fetch({ year }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.legalEntitiesByCampaignYear))
    }
}

export function convertLazyLoadToComplexWithPage(parameters: any): { query: LegalEntityQueryComplexInput, page: PagingInput } {
    const query: LegalEntitySimpleQueryInput[] = [];
    if (parameters) {

        if (parameters.filters) {

            Object.entries(parameters.filters).forEach(([field, values]) => {

                if (values !== null && Array.isArray(values) && values.length > 0) {
                    (ENUM_AUDIT_PLANS[field as keyof typeof ENUM_AUDIT_PLANS])?.forEach(key => {

                        query.push({
                            field: key as LegalEntityFields,
                            filters: {
                                operator: ComparatorOperators.Match,
                                value: key === LegalEntityFields.LegalEntityCode ? values.map(v => v?.split(/\s-\s(.+)/)[0]?.trim()) : values
                            }
                        });
                    })
                }
            });
        }
    }
    return {
        query: {
            operator: OperatorInput.And,
            query: [
                {
                    query: query,
                    operator: OperatorInput.And
                }
            ]
        },
        page: {
            pageNo: parameters?.page ?? 0,
            pageSize: parameters?.rows ?? 1000000
        }
    }
}

export const ENUM_AUDIT_PLANS = {
    name: [LegalEntityFields.LegalEntityCode],
    legalEntity: [LegalEntityFields.LegalEntityCode],
    // bodPresentationDate: [LegalEntityFields.],
    // attachment: [LegalEntityFields.AuditAttachmentsQuantity],
    // localSuperuserPermission: [LegalEntityFields.AuditLocalSuperUserApproval],
    // galtChiefApproval: [LegalEntityFields.AuditGaltChiefApproval],
    // status: [LegalEntityFields.AuditPlanStatus],
    businessUnit: [LegalEntityFields.BusinessUnit],
    organizationalUnit: [LegalEntityFields.OrganizationalUnit],
    legalEntityName: [LegalEntityFields.LegalEntityCode],
    startDate: [LegalEntityFields.StartDate],
    legalEntitySize: [LegalEntityFields.LegalEntitySize],
    businessType: [LegalEntityFields.BusinessType],
    valueChain: [LegalEntityFields.ValueChain],
    category: [LegalEntityFields.Category],
    auditControlApproach: [LegalEntityFields.AuditControlApproach]
}